import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AdminAuditHistory from './admin-audit-history';
import AdminAuditHistoryDetail from './admin-audit-history-detail';
import AdminAuditHistoryUpdate from './admin-audit-history-update';
import AdminAuditHistoryDeleteDialog from './admin-audit-history-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AdminAuditHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AdminAuditHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AdminAuditHistoryDetail} />
      <ErrorBoundaryRoute path={match.url} component={AdminAuditHistory} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AdminAuditHistoryDeleteDialog} />
  </>
);

export default Routes;
